// Copyright (c) 2017 Deere & Company

import './home.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import {
    getSearchBy,
    getSearchBySelectedOption,
    isCloudPrefferred,
    mapSearchPlaceHolder
} from '../shared/services/home-page-helper';
import {
    getSearchBySapDown,
    mapSearchPlaceHolderSapDown
} from '../shared/services/home-page-helper-sap-down';
import CloudConfig from '../../shared/models/cloud-config';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import Favorite from '@deere/cps-it.warranty-model-factory/lib/favorite';
import Favorites from '../../shared/components/favorites/';
import {FormattedMessage} from 'react-intl';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import LaborAdditiveSummary from '@deere/cps-it.warranty-model-factory/lib/labor-additive-summary';
import LaborAdditiveSummaryList from '../../pip/labor-additive/components/labor-additive-summary/labor-additive-summary-list';
import LaborAdditiveSummaryModal from '../../pip/labor-additive/components/labor-additive-summary/labor-additive-summary-modal';
import Notification from '@deere/cps-it.warranty-model-factory/lib/notification';
import NotificationsList from './notifications';
import OfflineReports from './offline-reports';
import ReimbursementSummaryAside from '../../reimbursement-summary/summary/components/reimbursement-summary-aside';
import SearchBox from '../../shared/components/search-box';
import SearchBoxSapDown from '../../shared/components/search-box/search-box-sap-down';
import SearchByDropDown from '../state/search-by-dropdown';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import WarrantyLoadingIndicator from '../../shared/components/warranty-loading-indicator';
import Wip from '../state/wip';
import WipClaims from './wip-claims';
import WipPartReturns from './wip-part-returns';
import WipPips from './wip-pips';
import WipProductTrackings from './wip-product-tracking';
import {buildLaborAdditiveSummariesObject} from '../../pip/shared/services/build-labor-additive-summaries-object';
import {getIsPinTransferEnabled} from '../../product/shared/services/get-is-pin-transfer-enabled-aor';
import {getStore} from '../../store-factory';
import {hasAccess} from '../../shared/services/security';

function handleModalClose() {

    this.actions.updateLaborAdditiveSummaryModalVisibility(false);

}

function handleModalOpen(laborAdditiveSummary) {

    this.actions.updateLaborAdditiveSummary(laborAdditiveSummary);
    this.actions.updateLaborAdditiveSummaryModalVisibility(true);

}

function handleShowHideMoreGroups(areVisible) {

    this.actions.updateShowMoreGroupsVisibility(areVisible);

}

function handleSearch(query) {

    this.actions.onSearch(this.searchByDropDown.selectedOption.key, query);

}
function handleSearchSapDown(query) {

    this.actions.onSearchSapDown('PRODUCTS', query);

}

function handleSearchByDropdownChange(key) {

    this.props.actions.updateSearchByDropDown(key, this.state.searchBy);

}

function handlerFavorites(favoriteId) {

    this.actions.deleteFavorite(favoriteId);

}

class Home extends Component {

    state = {
        searchBy: getSearchBy(this.context.security),
        searchBySapDown: getSearchBySapDown(this.context.security),
        showLaborAdditive: hasAccess(this.context.security, 'PIP', 'PIP_LABOR_ADD_SUMM'),
        showWIP: hasAccess(this.context.security, 'WELCOME_PAGE', 'WELCOME_WIP')
    };

    /* eslint-disable complexity */

    componentWillMount() {

        this.props.actions.readNotifications();

        if (this.state.showWIP) {

            this.props.actions.readWip(isCloudPrefferred(getStore().getState().user.entitlements));
            this.props.actions.readOpenPipSummary();
            if (isCloudPrefferred(getStore().getState().user.entitlements)) {

                this.props.actions.readTransferApprovalCount(this.props.selectedAccounts);

            }

            if (getIsPinTransferEnabled('dealer-recommendation')) {

                this.props.actions.updateDealerRecommendationCountWithFacets(this.props.selectedAccounts);

            }

        }

        if (this.state.showLaborAdditive) {

            this.props.actions.readLaborAdditiveSummaries();

        }

        this.props.actions.updateSearchByDropDown(getSearchBySelectedOption(this.state.searchBy), this.state.searchBy);

    }

    componentWillUnmount() {

        this.props.actions.updateLaborAdditiveSummaryModalVisibility(false);

    }

    render() {

        const laborAdditiveSummariesObject = buildLaborAdditiveSummariesObject(this.props.laborAdditiveSummaries);

        return (
            <section className='home-placeholder'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <div className='status-indicators'>
                    {this.state.showWIP &&
                        <div>
                            <WipPips wipOpenPip={this.props.wip.openPips}/>
                            <WipClaims
                                claimStatuses={this.props.claimSettings}
                                wipClaim={this.props.wip.claims}
                            />
                            <WipPartReturns wipPartReturns={this.props.wip.returnParts}/>
                            <WipProductTrackings wipProductTracking={this.props.wip.productTracking}/>
                        </div>
                    }
                    {this.props.laborAdditiveSummaries.length > 0 && this.state.showLaborAdditive &&
                        <div className='home-page-labor-additive-panel'>
                            <header>
                                <FormattedMessage id='LABOR_ADDITIVE_PIPS'/>
                            </header>
                            <LaborAdditiveSummaryList
                                count={this.props.laborAdditiveSummaries.length}
                                isMoreSummaryVisible={this.props.isMoreSummaryVisible}
                                laborAdditiveSummariesObject={laborAdditiveSummariesObject}
                                onModalOpen={this.props::handleModalOpen}
                                showHideMoreGroups={this.props::handleShowHideMoreGroups}
                            />
                        </div>
                    }
                    <LaborAdditiveSummaryModal
                        isVisible={this.props.isVisible}
                        laborAdditiveSummary={this.props.laborAdditiveSummary}
                        onModalClose={this.props::handleModalClose}
                    />
                    {hasAccess(this.context.security, 'WELCOME_PAGE', 'WELCOME_REIMBURSEMENT') &&
                        <ReimbursementSummaryAside/>
                    }
                    {!this.props.isSapUp &&
                        <OfflineReports security={this.context.security}/>
                    }
                </div>
                <div className='notification-messages'>
                    {this.props.notifications.length > 0 &&
                        <NotificationsList
                            notifications={this.props.notifications}
                        />
                    }
                    {this.state.searchBySapDown.length > 0 && !this.props.isSapUp &&
                        <SearchBoxSapDown
                            defaultOption={'PRODUCTS'}
                            onQueryChange={this.props.actions.updateSearchQueryString}
                            onSearch={this.props::handleSearchSapDown}
                            placeholderText={mapSearchPlaceHolderSapDown('PRODUCTS')}
                            queryString={this.props.searchQueryString}
                            searchBy={'PRODUCTS'}
                        />
                    }
                    {this.state.searchBy.length > 0 && this.props.isSapUp &&
                        <SearchBox
                            defaultOption={this.props.searchByDropDown.selectedOption.key}
                            onOptionChange={this::handleSearchByDropdownChange}
                            onQueryChange={this.props.actions.updateSearchQueryString}
                            onSearch={this.props::handleSearch}
                            placeholderText={mapSearchPlaceHolder(this.props.searchByDropDown.selectedOption.key)}
                            queryString={this.props.searchQueryString}
                            searchBy={this.state.searchBy}
                        />
                    }
                    {this.props.favorites.length > 0 && this.props.isSapUp &&
                    <Favorites
                        favorites={this.props.favorites}
                        onhandleFavoritesClick={this.props::handlerFavorites}
                    />
                    }
                </div>
            </section>
        );

    }

}

Home.displayName = 'Home';
Home.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    claimSettings: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)),
    claimStatuses: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)),
    cloudConfig: PropTypes.instanceOf(CloudConfig).isRequired,
    favorites: PropTypes.arrayOf(Favorite).isRequired,
    isMoreSummaryVisible: PropTypes.bool.isRequired,
    isSapUp: PropTypes.bool.isRequired,
    isVisible: PropTypes.bool.isRequired,
    laborAdditiveSummaries: PropTypes.arrayOf(PropTypes.instanceOf(LaborAdditiveSummary)).isRequired,
    laborAdditiveSummary: PropTypes.instanceOf(LaborAdditiveSummary).isRequired,
    notifications: PropTypes.arrayOf(Notification).isRequired,
    searchByDropDown: PropTypes.instanceOf(SearchByDropDown).isRequired,
    searchQueryString: PropTypes.string.isRequired,
    selectedAccounts: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    userId: PropTypes.string.isRequired,
    wip: PropTypes.instanceOf(Wip).isRequired
};
Home.contextTypes = {
    security: PropTypes.instanceOf(Security).isRequired
};

export default Home;



// WEBPACK FOOTER //
// ./src/home-page/components/home.js